export const templates:[string,any][] = [
    [
        'PATIENT_FLOW_GEO_MSA_PROVIDER_TYPE_FACT',
        {
            version: 2,
            baseQueryGraph: {
                baseQuery: {
                    queryType: 'dim',
                    tableNodes: [
                        {
                            id: 'patient-flow-geo-msa-provider-type',
                            dataset: 'patient-flow-geo-msa-provider-type',
                            columns: [
                                'BEGIN_YEAR_KEY',
                                'END_YEAR_KEY',
                                'LOB',
                                'CBSA_DIM_KEY',
                                'ORIGIN_PROVIDER_TYPE',
                                'DEST_PROVIDER_TYPE',
                            ],
                        },
                    ],
                },
                joins: [],
            },
            sort: [],
            filters: [
                {
                    type: 'basic',
                    column: {
                        nodeId: 'patient-flow-geo-msa-provider-type',
                        column: 'lob',
                    },
                    test: '=',
                    value: 'CHSD_COM_IND',
                },
            ],
            transforms: [],
        },
    ],
    [
        'PATIENT_FLOW_GEO_MSA_PROVIDER_FACT',
        {
            version: 2,
            baseQueryGraph: {
                baseQuery: {
                    queryType: 'dim',
                    tableNodes: [
                        {
                            id: 'patient-flow-geo-msa-provider-type',
                            dataset: 'patient-flow-geo-msa-provider-type',
                            columns: [
                                'BEGIN_YEAR_KEY',
                                'END_YEAR_KEY',
                                'LOB',
                                'CBSA_DIM_KEY',
                                'ORIGIN_PROVIDER_TYPE',
                                'ORIGIN_PROVIDER_NUMBER',
                                'ORIGIN_FACILITY_DIM_KEY',
                                'DEST_PROVIDER_TYPE',
                                'DEST_PROVIDER_NUMBER',
                                'DEST_FACILITY_DIM_KEY',
                            ],
                        },
                    ],
                },
                joins: [],
            },
            sort: [],
            filters: [
                {
                    type: 'basic',
                    column: {
                        nodeId: 'patient-flow-geo-msa-provider-type',
                        column: 'lob',
                    },
                    test: '=',
                    value: 'CHSD_COM_IND',
                },
            ],
            transforms: [],
        },
    ],
    [
        'map-cbsa-net-patient-revenue',
        {
            version: 2,
            baseQueryGraph: {
                baseQuery: {
                    queryType: 'scaffold',
                    tableNodes: [
                        {
                            id: 'facility',
                            dataset: 'facility',
                            columns: [
                                'torch_facility_id',
                                'facility_name',
                                'longitude',
                                'latitude'
                            ]
                        },
                        {
                            id: 'hospital-market-share-cbsa',
                            dataset: 'hospital-market-share-cbsa',
                            columns: [
                                'cbsa',
                                'net_patient_revenue'
                            ]
                        }
                    ],
                    scaffoldField: 'year_key',
                    scaffoldType: 'max'
                },
                joins: []
            },
            sort: [
                {
                    column: {
                        nodeId: 'hospital-market-share-cbsa',
                        column: 'cbsa'
                    },
                    asc: true
                }
            ],
            filters: [
                {
                    type: 'basic',
                    column: {
                        nodeId: 'hospital-market-share-cbsa',
                        column: 'net_patient_revenue'
                    },
                    test: 'is not null',
                    value: ''
                },
                {
                    type: 'basic',
                    column: {
                        nodeId: 'hospital-market-share-cbsa',
                        column: 'cbsa'
                    },
                    test: 'is not null',
                    value: ''
                }
            ],
            transforms: []
        }
    ],
    [
        'sankey-vis-1',
        {
            version: 2,
            baseQueryGraph: {
                baseQuery: {
                    queryType: 'dim',
                    tableNodes: [
                        {
                            id: 'patient-flow-provider-condition-sankey',
                            dataset: 'patient-flow-provider-condition-sankey',
                            columns: [
                                'begin_year_key',
                                'end_year_key',
                                'lob',
                                'origin_provider_type',
                                'origin_provider_number',
                                'origin_facility_dim_key',
                                'origin_condition_category',
                                'origin_condition_category_code',
                                'dest_provider_type',
                                'dest_provider_number',
                                'dest_facility_dim_key',
                                'dest_condition_category',
                                'dest_condition_category_code',
                                'patients',
                                'episodes',
                                'origin_allowed',
                                'dest_allowed'
                            ]
                        }
                    ],
                    scaffoldType: ''
                },
                joins: []
            },
            sort: [],
            filters: [],
            transforms: []
        }
    ]
];
